import { Box, Typography } from '@material-ui/core';

import { useStyles } from './LandingCard.styles';

const LandingCard = ({ image, title, children, variant }) => {
  const classes = useStyles({ image, variant });

  return (
    <Box component="aside" className={classes.card}>
      <Typography variant="h6" className="title">
        {title}
      </Typography>
      <Box className="content">
        <Typography className={classes.text}>{children}</Typography>
      </Box>
    </Box>
  );
};

export default LandingCard;
